module.exports = __webpack_public_path__ + "img/clothing175.41182113.jpg";